import {
  initAppActionType,
  updateBearerActionType,
  AppActionTypes,
} from '../../model/application/actions';
import { createActions } from '../../helpers/actionsHelper';

export const appInitAction = createActions<AppActionTypes, {}, {}>(initAppActionType);

export function updateBearer(bearer: string): AppActionTypes {
  return {
    type: updateBearerActionType,
    payload: bearer,
  };
}